import { useState } from 'react';
import { Lock, LockOpen, Xmark } from '@gravity-ui/icons';
import { Button, Icon, Modal } from '@gravity-ui/uikit';

import { useBlockUserMutation } from 'store/api/private/user-api/admin-api';

import { BLOCK, BLOCK_ACC, BLOCK_QUESTION, CANCEL } from '../../constants';

import styles from './styles.module.scss';
import { toast } from 'react-toastify';

interface Person {
	id: number;
	email: string;
	role: string;
	firstName: string;
	middleName: string;
	lastName: string;
	establishment: {
		id?: number;
		name?: string | null;
	} | null;
	imageUrl: string;
	region: {
		code?: number;
		fullname: string;
		guid?: string;
		name?: string;
	};
	specialty: string;
	createdDate: string;
	active: boolean;
}

interface AccountBlockModalProps {
	account: Person;
	onAdd: () => void;
	updateAccountStatus: (updatedAccount: Person) => void;
}

export const AccountBlockModal = ({ account, onAdd, updateAccountStatus }: AccountBlockModalProps) => {
	const [open, setOpen] = useState(false);

	const [blockAcount] = useBlockUserMutation();

	const onSubmit = () => {
		blockAcount({ email: account.email });
		setOpen(false);
		updateAccountStatus({ ...account, active: true });
		onAdd();
		toast.success('Аккаунт специалиста успешно заблокирован');
	};

	return (
		<>
			<Button view="flat" size="l" onClick={() => setOpen(true)}>
				<Icon data={LockOpen} size={16} />
			</Button>

			<Modal open={open} onClose={() => setOpen(false)} className={`${styles.modal} ${styles.block}`}>
				<div className={styles.modal__title}>
					<h3>{BLOCK_ACC}</h3>

					<Xmark onClick={() => setOpen(false)} cursor="pointer" />
				</div>

				<div className={styles.modal__question}>{BLOCK_QUESTION}</div>

				<div className={styles.modal__btns}>
					<Button size="xl" view="flat-secondary" onClick={() => setOpen(false)}>
						{CANCEL}
					</Button>
					<Button size="xl" view="outlined-danger" onClick={() => onSubmit()}>
						{BLOCK}
					</Button>
				</div>
			</Modal>
		</>
	);
};
